import workspace from "./workspace";
import { getFilteredWorkspaceData } from "@/utils/workspaceOrgFilter";
import { useStore } from "@/store";

// Get all products
export const getProducts = async () => {
  const userOrg = useStore.userOrg();
  const params = { org_name: userOrg };
  try {
    return getFilteredWorkspaceData(`/products/`, 'organization', { params });
  } catch (error) {
    console.error("Error fetching products:", error);
    throw error;
  }
};

// Get a single product by ID
export const getProductById = async (id) => {
  try {
    const response = await workspace.get(`/products/${id}/`, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    return response.data;
  } catch (error) {
    console.error(`Error fetching product with ID ${id}:`, error);
    throw error;
  }
};

// Create a new product
export const createProduct = async (productData) => {
  try {
    const response = await workspace.post(`/products/`, productData);
    return response.data;
  } catch (error) {
    console.error("Error creating product:", error);
    throw error;
  }
};


export const uploadProductChunk = async (productId, formData) => {
  try {
    const response = await workspace.post(
      `/products/${productId}/chunks/`, 
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
        },
      }
    );
    return response.data;
  } catch (error) {
    console.error("Error uploading chunk:", error);
    throw error;
  }
};


export const updateProductsUsers = async (id, productData) => {
  try {
      const response = await workspace.post(`/products/${id}/users/`, productData, {
      });
      return response.data;
    } catch (error) {
      console.error(`Error updating agent with ID ${id}:`, error);
      throw error;
    }
}

// Update an existing product
export const updateProduct = async (id, productData) => {
  try {
    const response = await workspace.put(`/products/${id}/`, productData);
    return response.data;
  } catch (error) {
    console.error(`Error updating product with ID ${id}:`, error);
    throw error;
  }
};

// Delete a product
export const deleteProduct = async (id) => {
  try {
    const response = await workspace.delete(`/products/${id}/`);
    return response.data;
  } catch (error) {
    console.error(`Error deleting product with ID ${id}:`, error);
    throw error;
  }
};
